const { uiComponentsLocalizationData } = require('@repo/static-translations');
const {
  useInternationalHelper,
  useInternationalContext,
} = require('@repo/gatsby-localization-helpers');

// Static pages
const { blogPostPage } = require('./blogPostPage');
const { cartPage } = require('./cartPage');
const { notFoundPage } = require('./404Page');
const { searchPage } = require('./searchPage');
const { contactUsPage } = require('./contactUsPage');
const { glossaryPage } = require('./glossaryPage');
const { emailUpdatesPage } = require('./emailUpdatesPage');
const { emailUpdatesSuccessPage } = require('./emailUpdatesSuccessPage');
const { addressesPage } = require('./addressesPage');
const { accountPage } = require('./accountPage');
const { loginPage } = require('./loginPage');
const { registerPage } = require('./registerPage');
const { resetPasswordPage } = require('./resetPasswordPage');
const { accountSettingsPage } = require('./accountSettingsPage');
const { verifyAccountPage } = require('./verifyAccountPage');
const { logoutPage } = require('./logoutPage');
const { breadcrumbsCommon } = require('./breadcrumbsCommon');
const { internationalPage } = require('./internationalPage');

// Nodes + Templates
const { sharedPages } = require('./sharedPages');
const { commonLabels } = require('./commonLabels');
const { productDetailPage } = require('./productDetailPage');
const { collectionsPage } = require('./collectionsPage');
const { subscriptionPaymentPage } = require('./subscriptionPaymentPage');
const { subscriptionsPage } = require('./subscriptionsPage');
const {
  subscriptionPaymentMethodPanel,
} = require('./subscriptionPaymentMethodPanel');

const petsafeLocalizationStructure = {
  // Static pages
  cartPage,
  notFoundPage,
  searchPage,
  contactUsPage,
  glossaryPage,
  emailUpdatesPage,
  emailUpdatesSuccessPage,
  addressesPage,
  accountPage,
  loginPage,
  registerPage,
  resetPasswordPage,
  accountSettingsPage,
  verifyAccountPage,
  logoutPage,
  breadcrumbsCommon,
  internationalPage,

  // Nodes + Templates
  sharedPages,
  commonLabels,
  productDetailPage,
  collectionsPage,
  blogPostPage,
  subscriptionPaymentPage,
  subscriptionsPage,
  subscriptionPaymentMethodPanel,

  // UI components
  ...uiComponentsLocalizationData,
};

// eslint-disable-next-line arrow-body-style
const usePetsafeStaticContentLocalizer = locale => {
  // eslint-disable-next-line import/no-unresolved, global-require
  const translationCache = require('../../content/localization.json');
  return useInternationalHelper(
    locale,
    translationCache,
    petsafeLocalizationStructure
  );
};

const usePetsafeInternationalContext = () =>
  useInternationalContext(petsafeLocalizationStructure);

module.exports = {
  petsafeLocalizationStructure,
  usePetsafeStaticContentLocalizer,
  usePetsafeInternationalContext,
};
